// Ebru Yöresel Kars — tema JS
//
// TASARIM KURALLARI (bozmayın):
// 1) Bu dosyada erken `return` YOKTUR. Tümü tek bir DOMContentLoaded handler'ı
//    içinde olduğu için bir `return`, altındaki tüm özellikleri (sepete ekleme
//    dahil) sessizce iptal eder.
// 2) Dinleyiciler mümkün olduğunca `document` üzerine delege edilir. Böylece
//    Shopify tema editöründe bir bölüm yeniden render edildiğinde yeni DOM
//    düğümleri dinleyicisiz kalmaz.
// 3) Sepete ekleme mantığının TEK yeri bu dosyadır. Bölüm/snippet içinde ikinci
//    bir submit dinleyicisi tanımlanırsa aynı gönderim iki kez işlenir ve
//    ürünler 2 kat sepete eklenir.
document.addEventListener('DOMContentLoaded', function () {
  var kokYol = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ================= YARDIMCILAR ================= */

  /* cart.js'ten gelen ürün adları innerHTML'e gömüldüğü için kaçırılmalıdır */
  function kacir(deger) {
    return String(deger == null ? '' : deger).replace(/[&<>"']/g, function (k) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[k];
    });
  }

  /* Shopify sepet uçlarına ortak istek.
     Yanıt JSON olmayabilir (429/503/bot koruması HTML döndürür); bu yüzden önce
     metin okunup güvenli ayrıştırılır, aksi halde kullanıcıya JS ayrıştırma
     hatası gösterilirdi. */
  function sepetIstek(yol, govde) {
    return fetch(kokYol + yol, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    }).then(function (yanit) {
      return yanit.text().then(function (metin) {
        var veri = null;
        try { veri = JSON.parse(metin); } catch (e) { /* JSON değil */ }
        if (!yanit.ok || !veri || (veri.status && veri.status !== 200)) throw (veri || {});
        return veri;
      });
    });
  }

  /* Yalnızca Shopify'ın kullanıcıya dönük `description` alanı gösterilir;
     ham JS/HTTP hata metinleri müşteriye sızdırılmaz. */
  function sepetHatasi(hata) {
    var aciklama = hata && hata.description;
    alert(typeof aciklama === 'string' && aciklama
      ? aciklama
      : 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
  }

  /* ================= MOBİL MENÜ ================= */
  var menuOncekiOdak = null;

  function menuAc() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var ortu = document.querySelector('[data-menu-ortu]');
    if (!drawer || !ortu) return;
    menuOncekiOdak = document.activeElement;
    drawer.classList.add('acik');
    ortu.classList.add('acik');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var kapat = drawer.querySelector('[data-menu-kapat]');
    if (kapat) kapat.focus();
  }

  function menuKapat() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var ortu = document.querySelector('[data-menu-ortu]');
    if (!drawer || !ortu) return;
    drawer.classList.remove('acik');
    ortu.classList.remove('acik');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (menuOncekiOdak && menuOncekiOdak.focus) menuOncekiOdak.focus();
    menuOncekiOdak = null;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.mobil-menu-btn')) { menuAc(); return; }
    if (e.target.closest('[data-menu-kapat]') || e.target.closest('[data-menu-ortu]')) menuKapat();
  });

  /* ================= ÜRÜN GALERİSİ ================= */
  document.addEventListener('click', function (e) {
    var img = e.target.closest('.u-galeri .kucukler img');
    if (!img) return;
    var sarmal = img.closest('.u-galeri');
    var galeri = sarmal && sarmal.querySelector('.ana');
    if (!galeri) return;
    var kardesler = Array.prototype.slice.call(img.parentElement.children);
    var sira = parseInt(img.dataset.sira, 10);
    if (isNaN(sira)) sira = kardesler.indexOf(img);
    galeri.scrollTo({ left: sira * galeri.clientWidth, behavior: 'smooth' });
  });

  /* ================= FOOTER AKORDEONU (mobil) ================= */
  document.addEventListener('click', function (e) {
    var baslik = e.target.closest('.f-kolon h4');
    if (!baslik || !baslik.parentElement) return;
    baslik.parentElement.classList.toggle('acik');
  });

  /* ================= ADET KUTUSU (+/−) ================= */
  document.addEventListener('click', function (e) {
    var dugme = e.target.closest('[data-eksi], [data-arti]');
    if (!dugme) return;
    var kutu = dugme.closest('.adet-kutu');
    var girdi = kutu && kutu.querySelector('input');
    if (!girdi) return;
    var simdiki = parseInt(girdi.value, 10);
    if (isNaN(simdiki)) simdiki = 1;
    girdi.value = dugme.hasAttribute('data-arti') ? simdiki + 1 : Math.max(1, simdiki - 1);
  });

  /* ================= SCROLL REVEAL ================= */
  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if (!azHareket && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (girisler) {
      girisler.forEach(function (g) {
        if (g.isIntersecting) { g.target.classList.add('gorunur'); io.unobserve(g.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
  }

  /* CSS bu öğeleri `opacity:0` ile gizler; `gorunur` sınıfı gelmezse bölüm
     görünmez kalır. Tema editöründe yeni render edilen bölümler için tekrar
     çağrılır. */
  function revealBagla(kok) {
    var kapsam = kok && kok.querySelectorAll ? kok : document;
    var liste = [];
    if (kapsam.matches && kapsam.matches('.reveal, .kademe, .reels-fan')) liste.push(kapsam);
    kapsam.querySelectorAll('.reveal, .kademe, .reels-fan').forEach(function (el) { liste.push(el); });
    liste.forEach(function (el) {
      if (el.classList.contains('gorunur')) return;
      if (io) io.observe(el); else el.classList.add('gorunur');
    });
  }
  revealBagla(document);
  document.addEventListener('shopify:section:load', function (e) { revealBagla(e.target); });

  /* ================= SEPET SAYFASI ================= */

  /* "Kaldır": url_to_remove satır anahtarına (key) dayanır; anahtar eskidiğinde
     Shopify "geçerli kimlik veya satır parametresi yok" hata sayfası döndürür.
     Satır numarası (line) ile /cart/change.js bu hatayı ortadan kaldırır.
     JS çalışmazsa bağlantının kendi href'i yedek olarak devrededir. */
  document.addEventListener('click', function (e) {
    var baglanti = e.target.closest('[data-sepet-kaldir]');
    if (!baglanti) return;
    e.preventDefault();
    if (baglanti.dataset.calisiyor === '1') return;
    baglanti.dataset.calisiyor = '1';
    sepetIstek('cart/change.js', { line: +baglanti.dataset.line, quantity: 0 })
      .then(function () { window.location.reload(); })
      .catch(function (hata) {
        baglanti.dataset.calisiyor = '0';
        sepetHatasi(hata);
      });
  });

  /* Adet değişikliği anında kaydedilir; "Sepeti Güncelle"ye basılmadan ödemeye
     geçilse bile sepet günceldir. */
  document.addEventListener('change', function (e) {
    var girdi = e.target.closest('[data-sepet-adet]');
    if (!girdi || girdi.dataset.calisiyor === '1') return;

    /* Alan boşaltılıp odak kaybedilirse quantity:0 gidip ürün sessizce silinirdi.
       Geçersiz girdide istek atılmaz, önceki değer geri yazılır. */
    var ham = String(girdi.value).trim();
    var adet = parseInt(ham, 10);
    if (ham === '' || isNaN(adet) || adet < 0) {
      girdi.value = girdi.defaultValue;
      return;
    }

    girdi.dataset.calisiyor = '1';
    girdi.disabled = true;
    sepetIstek('cart/change.js', { line: +girdi.dataset.line, quantity: adet })
      .then(function () { window.location.reload(); })
      .catch(function (hata) {
        girdi.disabled = false;
        girdi.dataset.calisiyor = '0';
        girdi.value = girdi.defaultValue;
        sepetHatasi(hata);
      });
  });

  /* ================= SEPET DRAWER ================= */
  var drawer = document.querySelector('[data-sepet-drawer]');
  var ortu = document.querySelector('[data-drawer-ortu]');
  var drawerVar = !!(drawer && ortu);
  var drawerOncekiOdak = null;

  function paraBicim(kurus) {
    var kalip = document.body.dataset.para || '{{amount}} TL';
    var tutar = (kurus / 100).toFixed(2).replace('.', ',');
    tutar = tutar.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return kalip
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, tutar)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, tutar.split(',')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, tutar);
  }

  /* Liquid tarafı money_without_trailing_zeros kullanıyor; JS'in de aynı biçimi
     üretmesi gerekir, yoksa AJAX sonrası "3.000 TL" → "3.000,00 TL" olur. */
  function paraBicimKurussuz(kurus) {
    var kalip = document.body.dataset.para || '{{amount}} TL';
    var tutar = String(Math.round(kurus / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return kalip
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, tutar)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, tutar)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, tutar)
      .replace(/\{\{\s*amount\s*\}\}/g, tutar);
  }

  /* ---------- Sepet indirimi ilerleme çubuğu ----------
     Mantık snippets/indirim-ilerleme.liquid ile birebir aynıdır; orada Liquid,
     burada AJAX sonrası JS hesaplar. Karşılaştırma items_subtotal_price üzerinden
     yapılır (Shopify'ın minimum tutar koşulu da ara toplamı baz alır). */
  function ilerlemeYenile(sepet) {
    if (!sepet) return;
    var ara = sepet.items_subtotal_price || 0;
    var adet = sepet.item_count || 0;

    document.querySelectorAll('[data-ind-ilerleme]').forEach(function (kok) {
      var k1e = parseInt(kok.getAttribute('data-k1-esik'), 10) || 0;
      var k1i = parseInt(kok.getAttribute('data-k1-indirim'), 10) || 0;
      var k2e = parseInt(kok.getAttribute('data-k2-esik'), 10) || 0;
      var k2i = parseInt(kok.getAttribute('data-k2-indirim'), 10) || 0;
      if (!k1e) return;

      kok.hidden = adet === 0;
      if (adet === 0) return;

      var ikiKademe = k2e > k1e;
      var tavan = ikiKademe ? k2e : k1e;
      var oran = Math.min(100, Math.floor(ara * 100 / tavan));

      var kazanim = 0;
      var mesaj;
      if (ara < k1e) {
        mesaj = '<b>' + paraBicimKurussuz(k1e - ara) + '</b> daha ekle, <b>' +
                paraBicimKurussuz(k1i) + ' indirim</b> kazan';
      } else if (ikiKademe && ara < k2e) {
        kazanim = 1;
        mesaj = '<b>' + paraBicimKurussuz(k1i) + ' indirim</b> kazandın · <b>' +
                paraBicimKurussuz(k2e - ara) + '</b> daha ekle, <b>' +
                paraBicimKurussuz(k2i) + '</b> indirime yükselt';
      } else {
        kazanim = 2;
        mesaj = ikiKademe
          ? 'En yüksek kademedesin: <b>' + paraBicimKurussuz(k2i) + ' indirim</b> kazandın'
          : '<b>' + paraBicimKurussuz(k1i) + ' indirim</b> kazandın';
      }

      var mesajEl = kok.querySelector('[data-ii-mesaj]');
      if (mesajEl) mesajEl.innerHTML = mesaj;

      var dolgu = kok.querySelector('[data-ii-dolgu]');
      if (dolgu) dolgu.style.width = oran + '%';

      var ray = kok.querySelector('[data-ii-ray]');
      if (ray) ray.setAttribute('aria-valuenow', oran);

      var n1 = kok.querySelector('[data-ii-nokta1]');
      if (n1) n1.classList.toggle('aktif', kazanim >= 1);
      var n2 = kok.querySelector('[data-ii-nokta2]');
      if (n2) n2.classList.toggle('aktif', kazanim >= 2);
      var e1 = kok.querySelector('[data-ii-et1]');
      if (e1) e1.classList.toggle('aktif', kazanim >= 1);
      var e2 = kok.querySelector('[data-ii-et2]');
      if (e2) e2.classList.toggle('aktif', kazanim >= 2);
    });
  }

  function drawerAc() {
    if (!drawerVar) return;
    drawerOncekiOdak = document.activeElement;
    drawer.classList.add('acik');
    ortu.classList.add('acik');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var kapat = drawer.querySelector('[data-drawer-kapat]');
    if (kapat) kapat.focus();
  }

  function drawerKapat() {
    if (!drawerVar) return;
    drawer.classList.remove('acik');
    ortu.classList.remove('acik');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerOncekiOdak && drawerOncekiOdak.focus) drawerOncekiOdak.focus();
    drawerOncekiOdak = null;
  }

  /* Sepet adedi göstergeleri drawer olmasa da güncellenmelidir */
  function sepetSayaclari(sepet) {
    document.querySelectorAll('.sepet-sayi').forEach(function (s) {
      s.textContent = sepet.item_count;
    });
    document.querySelectorAll('[data-drawer-ac]').forEach(function (a) {
      a.setAttribute('aria-label', 'Sepet, ' + sepet.item_count + ' ürün');
    });
  }

  function drawerYenile(sepet) {
    if (!sepet) return;
    sepetSayaclari(sepet);
    ilerlemeYenile(sepet);   // boş sepette de çalışmalı: çubuğu gizler
    if (!drawerVar) return;

    var icerik = drawer.querySelector('[data-sd-icerik]');
    var alt = drawer.querySelector('[data-sd-alt]');
    var adetEtiketi = drawer.querySelector('[data-sd-adet]');
    if (adetEtiketi) adetEtiketi.textContent = '(' + sepet.item_count + ')';
    if (!icerik) return;

    if (sepet.item_count === 0) {
      icerik.innerHTML = '<div class="sd-bos"><p>Sepetiniz şu an boş.</p>' +
        '<a href="' + kokYol + 'collections/all" class="btn btn-koyu">Alışverişe Başla</a></div>';
      if (alt) alt.hidden = true;
      return;
    }
    if (alt) alt.hidden = false;

    var toplamEl = drawer.querySelector('[data-sd-toplam]');
    if (toplamEl) toplamEl.textContent = paraBicim(sepet.total_price);

    var indSatir = drawer.querySelector('[data-sd-indirim]');
    if (indSatir) {
      var toplamInd = sepet.total_discount || 0;
      indSatir.hidden = toplamInd === 0;
      var indTutar = drawer.querySelector('[data-sd-indirim-tutar]');
      if (toplamInd > 0 && indTutar) {
        indTutar.textContent = '−' + paraBicim(toplamInd);
      }
    }

    var html = '';
    (sepet.items || []).forEach(function (u, sira) {
      var satir = sira + 1; // /cart/change.js line parametresi 1 tabanlıdır
      var gorsel = u.image
        ? '<img class="sdg" src="' + kacir(u.image.replace(/(\.[a-z]{3,4})(\?|#|$)/i, '_160x$1$2')) +
          '" alt="" width="72" height="72">'
        : '<span class="sdg"></span>';
      var varyant = (u.variant_title && u.variant_title !== 'Default Title')
        ? '<span class="sd-varyant">' + kacir(u.variant_title) + '</span>' : '';
      var indirimli = u.original_line_price > u.final_line_price;
      var indEtiket = '';
      if (indirimli) {
        var adlar = (u.line_level_discount_allocations || []).map(function (d) {
          return d.discount_application && d.discount_application.title ? d.discount_application.title : 'İndirim';
        }).join(' · ');
        indEtiket = '<span class="sd-ind">' + kacir(adlar || 'İndirim') + ' · −' +
          paraBicim(u.original_line_price - u.final_line_price) + '</span>';
      }
      var fiyatHtml = indirimli
        ? '<s>' + paraBicim(u.original_line_price) + '</s>' + paraBicim(u.final_line_price)
        : paraBicim(u.final_line_price);
      html += '<div class="sd-urun">' + gorsel +
        '<div><b>' + kacir(u.product_title) + '</b>' + varyant + indEtiket +
        '<div class="sd-adet">' +
        '<button type="button" data-sd-eksi data-line="' + satir + '" aria-label="Azalt">−</button>' +
        '<span>' + kacir(u.quantity) + '</span>' +
        '<button type="button" data-sd-arti data-line="' + satir + '" aria-label="Artır">+</button>' +
        '</div></div>' +
        '<span class="sd-fiyat">' + fiyatHtml + '</span></div>';
    });
    icerik.innerHTML = html;
  }

  function sepetGetir() {
    return fetch(kokYol + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (c) { return c.json(); })
      .then(function (sepet) {
        drawerYenile(sepet);
        return sepet;
      });
  }

  window.EbruSepet = { ac: drawerAc, yenile: sepetGetir };

  /* Satır anahtarı (key) yerine satır numarası (line) kullanılır; key sepet
     değiştikçe eskiyip "geçerli kimlik veya satır parametresi yok" hatası verir. */
  var adetIstegiSuruyor = false;
  function adetDegistir(satir, yeniAdet) {
    if (adetIstegiSuruyor || !drawerVar) return;
    adetIstegiSuruyor = true;
    /* Butonlar kilitlenmezse hızlı tıklamalar sessizce yutulur ve kullanıcı
       butonun bozuk olduğunu düşünür. */
    drawer.querySelectorAll('[data-sd-arti], [data-sd-eksi]').forEach(function (b) {
      b.disabled = true;
    });
    sepetIstek('cart/change.js', { line: satir, quantity: Math.max(0, yeniAdet) })
      .then(drawerYenile)
      .catch(function (hata) {
        sepetHatasi(hata);
        return sepetGetir(); // sunucudaki gerçek durumla eşitle
      })
      .finally(function () { adetIstegiSuruyor = false; });
  }

  if (drawerVar) {
    document.addEventListener('click', function (e) {
      var ac = e.target.closest('[data-drawer-ac]');
      if (ac) { e.preventDefault(); drawerAc(); return; }
      if (e.target.closest('[data-drawer-kapat]')) { drawerKapat(); return; }
      if (e.target === ortu) { drawerKapat(); return; }

      var arti = e.target.closest('[data-sd-arti]');
      var eksi = e.target.closest('[data-sd-eksi]');
      if (!arti && !eksi) return;
      var dugme = arti || eksi;
      var adetKutusu = dugme.parentElement && dugme.parentElement.querySelector('span');
      var simdiki = adetKutusu ? (parseInt(adetKutusu.textContent, 10) || 1) : 1;
      adetDegistir(+dugme.dataset.line, arti ? simdiki + 1 : simdiki - 1);
    });
  }

  /* Escape: açık olan katmanı kapatır */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    menuKapat();
    drawerKapat();
  });

  /* ================= SEPETE EKLE =================
     Drawer bulunmasa bile çalışır; drawer yoksa yalnızca açılış adımı atlanır. */
  var eklemeSuruyor = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (e.defaultPrevented) return;   // 1) başka bir dinleyici gönderimi devraldı
    e.preventDefault();
    if (eklemeSuruyor) return;        // 2) devam eden bir ekleme isteği var
    if (form.dataset.ekleniyor === '1') return;
    eklemeSuruyor = true;
    form.dataset.ekleniyor = '1';     // 3) aynı formda çift tıklama

    var dugme = form.querySelector('[type="submit"]');
    var eskiYazi = dugme ? dugme.textContent : '';
    if (dugme) { dugme.disabled = true; dugme.textContent = 'Ekleniyor…'; }

    function kilidiAc() {
      eklemeSuruyor = false;
      form.dataset.ekleniyor = '0';
      if (dugme) { dugme.disabled = false; dugme.textContent = eskiYazi; }
    }

    /* Varyant kimliği yoksa (ör. bir uygulamanın enjekte ettiği form) bu formu
       yönetmeye çalışmayız; kilidi bırakıp native gönderime düşeriz. Aksi halde
       kilit açık kalır ve sitedeki tüm "Sepete Ekle" butonları ölürdü. */
    var idAlani = form.querySelector('[name="id"]');
    if (!idAlani || !idAlani.value) {
      kilidiAc();
      form.submit();
      return;
    }

    var adetGirdi = form.querySelector('[name="quantity"]');
    var kalemler = [{
      id: +idAlani.value,
      quantity: adetGirdi ? (parseInt(adetGirdi.value, 10) || 1) : 1
    }];
    /* "Yanına ekle" kutuları: yalnızca ana ürünle birlikte, adet 1 olarak eklenir */
    form.querySelectorAll('[data-ek-secim]:checked').forEach(function (k) {
      var varyantId = +k.dataset.varyant;
      if (varyantId) kalemler.push({ id: varyantId, quantity: 1 });
    });

    sepetIstek('cart/add.js', { items: kalemler })
      .then(sepetGetir)
      .then(drawerAc)
      .catch(sepetHatasi)  // hata varsa form.submit() ile TEKRAR eklemiyoruz
      .finally(kilidiAc);
  });

  /* ================= ÜRÜN KARTINDA VARYANT SEÇİMİ =================
     Kart üzerindeki çipe basılınca fiyat, "Sepete Ekle"nin hedef varyantı ve
     stok durumu güncellenir — müşteri ürün sayfasına gitmeden seçim yapar.
     Delege edilmiştir: koleksiyon, arama, öne çıkanlar ve öneriler bölümlerinin
     hepsinde (AJAX ile gelenler dahil) çalışır. */
  document.addEventListener('click', function (e) {
    var cip = e.target.closest('[data-kart-varyantlar] .u-varyant');
    if (!cip) return;
    e.preventDefault();

    var kart = cip.closest('.urun');
    var kap = cip.closest('[data-kart-varyantlar]');
    if (!kart || !kap) return;

    kap.querySelectorAll('.u-varyant').forEach(function (b) {
      var secili = b === cip;
      b.classList.toggle('aktif', secili);
      b.setAttribute('aria-pressed', secili ? 'true' : 'false');
    });

    var idAlani = kart.querySelector('input[name="id"]');
    if (idAlani) idAlani.value = cip.getAttribute('data-varyant-id');

    var fiyatEl = kart.querySelector('[data-kart-fiyat]');
    if (fiyatEl) {
      var fiyat = parseInt(cip.getAttribute('data-fiyat'), 10) || 0;
      var karsilastirma = parseInt(cip.getAttribute('data-karsilastirma'), 10) || 0;
      var html = '';
      if (karsilastirma > fiyat) html += '<s>' + paraBicim(karsilastirma) + '</s>';
      fiyatEl.innerHTML = html + paraBicim(fiyat);
    }

    var btn = kart.querySelector('.mini-btn');
    if (btn) {
      var stokta = cip.getAttribute('data-stok') === '1';
      btn.disabled = !stokta;
      btn.textContent = stokta ? 'Sepete Ekle' : 'Tükendi';
    }
  });

  /* `:has()` desteklemeyen tarayıcılarda "yanına ekle" seçimi görsel geri
     bildirim vermez; sınıfı JS ile de yansıtırız. */
  document.addEventListener('change', function (e) {
    var kutu = e.target.closest('[data-ek-secim]');
    if (!kutu) return;
    var sarmal = kutu.closest('.ek-urun');
    if (sarmal) sarmal.classList.toggle('secili', kutu.checked);
  });
});
